/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import type {
  IErrorResponse,
  NotificationType,
  PaginationResponse,
} from '@/types';

import { useQuery } from '@tanstack/react-query';
import queryString from 'query-string';

import { urls } from '@/statics';

const usePopups = ({
  current = 1,
  pageSize = 100000,
  profile,
  isRead,
}: {
  current?: number;
  pageSize?: number;
  profile: boolean;
  isRead?: boolean;
}) =>
  useQuery<PaginationResponse<NotificationType>, IErrorResponse>({
    queryKey: [
      `${urls.notifications}?${queryString.stringify({
        is_read: isRead,
        current,
        pageSize,
      })}`,
    ],
    enabled: Boolean(profile),
  });

export default usePopups;
